export const Segmented = ({ options, value, onChange, testPrefix, multi = false }) => (
  <div className="seg-group" role="group">
    {options.map((o) => {
      const active = multi ? value.includes(o.value) : value === o.value;
      return (
        <button
          key={o.value}
          type="button"
          data-testid={`${testPrefix}-${o.id ?? o.value}`}
          aria-pressed={active}
          className={`seg-btn ${active ? "seg-btn-active" : ""}`}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      );
    })}
  </div>
);
